import React from 'react';
import {Modal, Dialogue, Button, Text, Heading, LoadingSpinner, Icon} from '@albert-io/atomic';
import {history} from 'client/history';

import {withRouter} from 'react-router';

import {useShallow} from 'zustand/react/shallow';

import {useContentDiscoveryStore} from '../ContentDiscovery/store';
import {getAssignmentQuestionSets} from '../ContentDiscovery/ViewAssignment/ViewAssignment.queries';

type Props = {
  assignmentId: string;
  assignmentName?: string;
  handleClose: () => void;
  handleReassign?: () => void;
  router: any;
};

const handleReassignDefault = ({router}) => {
  router.push(`/assignment-builder/create-assignment/settings`);
};

const CustomizeReassignModal = ({
  assignmentId,
  assignmentName,
  handleClose,
  handleReassign,
  router
}: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const {setSelectedQuestionSets, setIsReassign, setDraftName} = useContentDiscoveryStore(
    useShallow((state) => ({
      setSelectedQuestionSets: state.draft.setSelectedQuestionSets,
      setIsReassign: state.assignment.setIsReassign,
      setDraftName: state.draft.setDraftName
    }))
  );

  const fetchAndSetQuestionSets = async () => {
    setIsLoading(true);
    const questions = await getAssignmentQuestionSets(assignmentId, true);
    setDraftName(`${assignmentName} (Reassigned)`);
    setIsReassign(true);
    setSelectedQuestionSets(questions);
    if (handleReassign) {
      handleReassign();
    } else {
      handleReassignDefault({
        router
      });
    }
    handleClose();
    setIsLoading(false);
  };

  return (
    <Modal ariaLabel='customize settings' handleClose={!isLoading ? handleClose : () => {}}>
      {({modalContentStyle}) => (
        <Dialogue
          inModal
          handleClose={!isLoading ? handleClose : () => {}}
          className={modalContentStyle}
          size='m'
        >
          <div className='flex flex-col items-center justify-center'>
            <Heading className='mt-x4' size='xl'>
              <Icon icon='info-circle' iconStyle='light' />
            </Heading>
            <Text bold className='mt-x5 text-center text-pretty'>
              Trying to adjust settings for specific students?
            </Text>
            <Text className='mt-x2 text-center text-pretty'>
              You can now customize time, due dates, and more for individual students by editing the
              assignment.
            </Text>
            {isLoading ? (
              <LoadingSpinner size={3} className='mt-x5' />
            ) : (
              <>
                <Button
                  variant='solid'
                  size='m'
                  className='mt-x5 mb-x1'
                  onClick={() => {
                    history.pushState(
                      null,
                      `/assignment-builder/create-assignment/${assignmentId}/settings`
                    );
                    handleClose();
                  }}
                >
                  Edit Assignment Settings
                </Button>
                <Button
                  variant='text'
                  size='m'
                  onClick={fetchAndSetQuestionSets}
                  data-testid='reassign-modal_reassign-button'
                >
                  Continue to Reassign
                </Button>
              </>
            )}
          </div>
        </Dialogue>
      )}
    </Modal>
  );
};

export default withRouter(CustomizeReassignModal);
